@if (user()) {
  @if (!isClient()) {
    <p class="settings__client-only">{{ copy.CLIENT_ONLY }}</p>
  } @else {
    <div class="settings">
      @if (showUnverified()) {
        <section class="settings__verify" aria-live="polite">
          <p class="settings__verify-text">{{ unverifiedText }}</p>
          <app-mail-cooldown-button
            channel="resend"
            [label]="copy.RESEND_BUTTON"
            [waitLabel]="copy.RESEND_WAIT"
            (send)="resendVerification()"
          />
          <p class="settings__notice settings__notice--resend" role="status">
            @if (view().resendNotice; as notice) {
              <span [class.settings__notice-text--error]="notice.tone === 'error'">{{ notice.text }}</span>
            }
          </p>
        </section>
      }

      <!-- Datos personales (A3) -->
      <section class="settings__block" aria-labelledby="settings-personal-title">
        <h2 id="settings-personal-title" class="settings__title">{{ copy.PERSONAL_TITLE }}</h2>
        <form class="settings__form" [formGroup]="personalForm" (ngSubmit)="savePersonal()" novalidate>
          <div class="settings__row">
            <app-input
              [id]="'settings-name'"
              formControlName="name"
              [label]="copy.NAME_LABEL"
              [error]="view().fieldErrors.name ?? ''"
            />
            <app-input
              [id]="'settings-surnames'"
              formControlName="surnames"
              [label]="copy.SURNAMES_LABEL"
              [error]="view().fieldErrors.surnames ?? ''"
            />
          </div>
          <app-input
            [id]="'settings-phone'"
            type="tel"
            formControlName="phone"
            [label]="copy.PHONE_LABEL"
            [error]="view().fieldErrors.phone ?? ''"
          />
          <div class="settings__actions">
            <app-button
              type="submit"
              variant="primary"
              size="md"
              class="settings__save"
              [disabled]="!personalChanged() || !formsOwned()"
              [loading]="view().saving"
            >
              {{ copy.SAVE_BUTTON }}
            </app-button>
          </div>
          <p class="settings__notice settings__notice--personal" role="status">
            @if (view().personalNotice; as notice) {
              <span [class.settings__notice-text--error]="notice.tone === 'error'">{{ notice.text }}</span>
            }
          </p>
        </form>
      </section>

      <!-- Correo (PUT /users/{id}) -->
      <section class="settings__block" aria-labelledby="settings-email-title">
        <h2 id="settings-email-title" class="settings__title">{{ copy.EMAIL_TITLE }}</h2>
        <form class="settings__form" [formGroup]="emailForm" (ngSubmit)="changeEmail()" novalidate>
          <app-input
            [id]="'settings-email'"
            type="email"
            formControlName="email"
            [label]="copy.EMAIL_LABEL"
            [error]="view().emailError ?? ''"
          />
          <p class="settings__hint">{{ copy.EMAIL_HINT }}</p>
          <div class="settings__actions">
            <app-button
              type="submit"
              variant="secondary"
              size="md"
              class="settings__email-submit"
              [disabled]="!emailChanged() || !formsOwned()"
              [loading]="view().emailSaving"
            >
              {{ copy.EMAIL_BUTTON }}
            </app-button>
          </div>
          <p class="settings__notice settings__notice--email" role="status">
            @if (view().emailNotice; as notice) {
              <span [class.settings__notice-text--error]="notice.tone === 'error'">{{ notice.text }}</span>
            }
          </p>
        </form>
      </section>

      <!-- Contraseña (GET /restore-password) -->
      <section class="settings__block" aria-labelledby="settings-password-title">
        <h2 id="settings-password-title" class="settings__title">{{ copy.PASSWORD_TITLE }}</h2>
        <p class="settings__text">{{ passwordText() }}</p>
        <div class="settings__actions">
          <app-mail-cooldown-button
            channel="reset"
            [label]="copy.PASSWORD_BUTTON"
            [waitLabel]="copy.LINK_WAIT"
            (send)="sendResetLink()"
          />
        </div>
        <p class="settings__notice settings__notice--password" role="status">
          @if (view().passwordNotice; as notice) {
            <span [class.settings__notice-text--error]="notice.tone === 'error'">{{ notice.text }}</span>
          }
        </p>
      </section>
    </div>
  }
}
